import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  margin-bottom: 15px;
  padding: 20px 0;
  border: 1px solid ${({ theme }) => theme.colors.gray400};
  text-align: center;
  border-radius: 4px;
`;

export const Item = styled.div`
  margin-bottom: 14px;

  &:last-child {
    margin-bottom: 0;
  }
`;
